// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__yuH0S","title":"App_title__DgWjq","animeLeft":"App_animeLeft__1TBu3"};